export default "__VITE_ASSET__UdPT4Odr__"